import { isTauri } from '@tauri-apps/api/core';
import { getGetDeviceGroupsKey, updateDeviceGroup } from 'gen/client';
import { MouseEvent, useCallback } from 'react';
import { mutate } from 'swr';

import DeviceCard from 'kerberus-components/src/Components/Device/DeviceCard';
import PowerButton from 'kerberus-components/src/Components/Device/PowerButton';
import { useRenkiConfig } from 'kerberus-components/src/Utils/device/installationMetadata';

import type { DevicespecsDTO, InstanceDTO, UserUIDeviceGroupResponseDTO } from 'gen/model';

interface DeviceListItemProps {
    deviceGroup: UserUIDeviceGroupResponseDTO;
    deviceSpec: DevicespecsDTO | undefined | null;
    selectedInstance: InstanceDTO | null | undefined;
}

export default function DeviceListItem({ deviceGroup, deviceSpec }: Readonly<DeviceListItemProps>) {
    const { config } = useRenkiConfig();
    const tauri = isTauri();

    /* Change device Tracking/Visibility */
    const handleDeviceTracking = useCallback(async (item: UserUIDeviceGroupResponseDTO) => {
        try {
            if (item.id) {
                await updateDeviceGroup(item.id, { visible: !item.visible });
            }
            void mutate(getGetDeviceGroupsKey());
        } catch (error) {
            alert(error);
        }
    }, []);

    const currentDevice = tauri && config?.installationId === deviceGroup.installation_id;

    const handlePower = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        void handleDeviceTracking(deviceGroup);
    };

    const powerButton = <PowerButton onClick={handlePower} size="medium" visible={deviceGroup.visible} />;

    return (
        <DeviceCard
            actionButton={powerButton}
            currentDevice={currentDevice}
            deviceGroup={deviceGroup}
            deviceImage={deviceSpec?.image}
            linkTo={`/device/${deviceGroup.id}`}
        />
    );
}
